import { Trip_v2 } from "../util/tripPlanner_types";
import { update_stayPin_opacity } from "./map/map_displays";

function filter_el(campEl:JQuery<HTMLElement>, campAttributes:string[], filters:Record<string,boolean>) {
	for (let filter in filters) {
		const class_for_missing_filter = `!${filter}`;
		if (filters[filter]) {
			if (!campAttributes.includes(filter) && !campEl.hasClass(class_for_missing_filter)) {
				campEl.addClass(class_for_missing_filter);
			} ;
		} else if (campEl.hasClass(class_for_missing_filter)) {
			campEl.removeClass(class_for_missing_filter);
		}
	};
};

export function filter_potential_stays(stayListWrapper:JQuery<HTMLElement>) {
	const filterPanel:JQuery<HTMLElement> = $("#stayFilters");
	const filterS2n:boolean = filterPanel.find("#s2nFilter").is(":checked");
	const amenityFilters:Record<string,boolean> = {};
	filterPanel.find("[amenityFilter]").each(function(){
		amenityFilters[this.id] = (this as HTMLInputElement).checked;
	});

	const activityFilters:Record<string,boolean> = {};
	filterPanel.find("[activityFilter]").each(function() {
		activityFilters[this.id] = (this as HTMLInputElement).checked;
	});

	let min_site_len:number = parseInt(filterPanel.find("#siteLength").val().toString());
	if (!Number.isNaN(min_site_len) && min_site_len < 0) {
		min_site_len = 0;
		filterPanel.find("#siteLength").val(0);
	};

	let site_price:number = parseInt(filterPanel.find("#sitePrice").val().toString());
	if (!Number.isNaN(site_price) && site_price < 0) {
		site_price = NaN;
		filterPanel.find("#sitePrice").val("");
	};

	let n_filters_active = filterPanel.find("[amenityFilter]:checked").length;
	n_filters_active += filterPanel.find("[activityFilter]:checked").length;
	n_filters_active += filterS2n? 1: 0;
	n_filters_active += min_site_len > 0? 1: 0;
	n_filters_active += Number.isNaN(site_price)? 0: 1;

	const hiddenCampIDs:number[] = [];

	stayListWrapper.children().each(function(idx, el) {
		const camp_attributes_el:JQuery<HTMLElement> = $(el).find("[camp_attributes]");

		const is_s2n:boolean = camp_attributes_el.attr("s2n") == "true";
		if (filterS2n && !is_s2n) {
			$(el).addClass("!s2n");
		} else {
			$(el).removeClass("!s2n");
		}

		const amenities_str:string|undefined = camp_attributes_el.attr("amenities");
		const amenities:string[] = amenities_str == undefined? []: amenities_str.split(",");
		filter_el($(el), amenities, amenityFilters);

		const activities_str:string|undefined = camp_attributes_el.attr("activities");
		const activities:string[] = activities_str == undefined? []: activities_str.split(",");
		filter_el($(el),activities, activityFilters);


		if (!Number.isNaN(min_site_len)) {
			let rv_len:number = parseInt(camp_attributes_el.attr("rv_len"));
			if (Number.isNaN(rv_len)) rv_len = 0;
			if (rv_len < min_site_len) {
				if (!$(el).hasClass("!siteLen")) $(el).addClass("!siteLen");
			} else {
				$(el).removeClass("!siteLen");
			};
		} else {
			$(el).removeClass("!siteLen");
		};
		if (!Number.isNaN(site_price)) {
			let p_low:number = parseInt(camp_attributes_el.attr("p_low"));
			if (Number.isNaN(p_low)) p_low = Infinity;
			if (p_low > site_price) {
				if (!$(el).hasClass("!sitePrice")) $(el).addClass("!sitePrice");
			} else {
				$(el).removeClass("!sitePrice");
			};
		} else {
			$(el).removeClass("!sitePrice")
		}

		if (el.classList.toString().includes("!")) {
			hiddenCampIDs.push(parseInt(el.id));
			if (!el.classList.contains("d-none")) {
				el.classList.add("d-none");
			};
		} else if (!el.classList.toString().includes("!") && el.classList.contains("d-none")) {
			el.classList.remove("d-none");
		};
	});
	update_stayPin_opacity(hiddenCampIDs);

	const n_stay_results = stayListWrapper.find("[unaddedstay]").filter(":not(.d-none)").length;
	$("#stayFilter-showResults").html(`Show ${n_stay_results} Results`);

	$("#stopPopout_n_camps").html(`Showing ${n_stay_results} results`);

	if (n_filters_active < 9) {
		$("[view-stay-filters].value-circle-disp").attr("data-value", n_filters_active);
	} else {
		$("[view-stay-filters].value-circle-disp").attr("data-value","9+");
	}
};

export function remove_avoid_area(el:JQuery<HTMLElement>) {
	const wrapper = el.closest("[avoid-area-entry-wrap]");
	const avoidEntryId = wrapper.attr("id");
	if (window.tripPlannerCurrentTrip.filters.avoidAreas) {
		for (let i = 0; i < window.tripPlannerCurrentTrip.filters.avoidAreas.length; i++) {
			if (window.tripPlannerCurrentTrip.filters.avoidAreas[i].id == avoidEntryId) {
				window.tripPlannerCurrentTrip.filters.avoidAreas.splice(i, 1);
				break;
			};
		}
	};
	wrapper.remove();
	$("#recalculate").removeClass("disabled");
};

export function set_tripFilters(trip: Trip_v2, wrapperEl:JQuery<HTMLElement>|null): void {
	let driveTime: number;
	let routeWidth: number;
	let driveDist: number | string;
	let avoidHighways: boolean;
	let avoidTolls: boolean;
	let avoidFerries: boolean;
	let avoidTunnels: boolean;
	let useFullDriveDist:boolean;
	let vehicleType:string;
	if (wrapperEl != null) {
		driveDist = wrapperEl.find("#drive-dist").val() as number | string;

		if (Number.isNaN(driveDist)) {
			driveDist = 300;
			$("#drive-dist").val(driveDist);
		};

		avoidHighways = wrapperEl.find("#avoid-highways").prop("checked");
		avoidTolls = wrapperEl.find("#avoid-tolls").prop("checked");
		avoidFerries = wrapperEl.find("#avoid-ferries").prop("checked");
		avoidTunnels = wrapperEl.find("#avoid-tunnels").prop("checked");

		useFullDriveDist = wrapperEl.find("#driveDistOption").val() == "full";

		if (wrapperEl.find("#vehicleType").length == 0) {
			vehicleType = ""
		} else {
			vehicleType = wrapperEl.find("#vehicleType").val().toString().toLowerCase();
		};
	} else {
		driveDist = $("#drive-dist").val() as number | string;

		if (Number.isNaN(driveDist)) {
			driveDist = 300;
			$("#drive-dist").val(driveDist);
		};

		avoidHighways = $("#avoid-highways").prop("checked");
		avoidTolls = $("#avoid-tolls").prop("checked");
		avoidFerries = $("#avoid-ferries").prop("checked");
		avoidTunnels = $("#avoid-tunnels").prop("checked");

		useFullDriveDist = $("#driveDistOption").val() == "full";

		if ($("#vehicleType").length == 0) {
			vehicleType = ""
		} else {
			vehicleType = $("#vehicleType").val().toString().toLowerCase();
		};
	};

	if (typeof (driveDist) == "string") {
		driveDist = parseInt(driveDist);
	};



	if (!["rv","car"].includes(vehicleType)) {
		vehicleType = "rv";
	};

	let avoidAreas:any;
	if (trip.filters) {
		avoidAreas = trip.filters.avoidAreas;
		if (!avoidAreas) {
			avoidAreas = [];
		};
	} else {
		avoidAreas = [];
	};
	$("#avoid-areas-entries").children().each(function(idx, el) {
		const id = $(el).attr("id");
		const name = $(el).find("[avoid-area-name]").val().toString();
		if (window.tripPlannerCurrentTrip.filters.avoidAreas == undefined) {
			window.tripPlannerCurrentTrip.filters.avoidAreas = [];
		};
		for (let i = 0; i < window.tripPlannerCurrentTrip.filters.avoidAreas.length; i++) {
			if (window.tripPlannerCurrentTrip.filters.avoidAreas[i].id == id) {
				return;
			};
		};
		window.tripPlannerCurrentTrip.filters.avoidAreas.push({
			name: name,
			id: id,
			bounds: null
		});
	});
	let avoidStates:any;
	if (trip.filters) {
		if (!trip.filters.avoidStates) {
			trip.filters.avoidStates = [];
		};
		avoidStates = trip.filters.avoidStates;
	} else {
		avoidStates = [];
	};
	$("[avoid-state]:checked").each(function(idx, el) {
		const state = $(el).attr("avoid-state").toString();
		if (!avoidStates.includes(state)) {
			avoidStates.push(state);
		};
	});

	let dist_unit:string;
	if ($("[dist-unit-select]").length) {
		dist_unit = $("[dist-unit-select]").val().toString();
	} else {
		dist_unit = "mi";
	};
	console.log($("[dist-unit-select]"),$("[dist-unit-select]").val());

	trip.filters = {
		driveTime: driveTime,
		driveDist: driveDist,
		routeWidth: routeWidth,
		avoidHighways: avoidHighways,
		avoidTolls: avoidTolls,
		avoidFerries: avoidFerries,
		avoidTunnels: avoidTunnels,
		useFullDriveDist: useFullDriveDist,
		vehicleType: vehicleType as "car"|"rv",
		avoidAreas: avoidAreas,
		avoidStates: avoidStates,
		dist_unit: dist_unit
	};
	console.log(trip.filters)
};